import {AppContext} from "../../../lib/AppContext";
import React, {forwardRef, useContext, useEffect, useState} from "react";
import {addDate, displayDay, formatCurrency, formatDate, inventoryAvailable} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {useSearchParams} from "react-router-dom";
import {getClientInventoryEvents, getInventoryEvents} from "../../common/api/InventoryApi";
import {ButtonGroup, Chip, Divider, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import * as pagination from "../../common/pagination";
import Icon from "@mui/material/Icon";
import Loading from "../../common/Loading";
import Avatar from "@mui/material/Avatar";
import {Col, Row} from "react-bootstrap";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import Button from "@mui/material/Button";

export default function EventsMiniCard(props) {

  const registerFn = props.register || null;
  const [context, setContext] = useContext(AppContext);
  const [client, setClient] = useState(null);
  const [specialEvents, setSpecialEvents] = useState(props?.specialEvents);

  const registerMembershipEvent = (event, memberAccount) => {
    let e = {...event};
    e.memberAccount = {...memberAccount};
    registerFn(e);
  }

  useEffect(() => {
    if (props.client) {
      setClient(props.client);
    }
    setEventDate(new Date());
  }, [props?.client]);

  const [eventsLoading, setEventsLoading] = useState(true);
  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [events, setEvents] = useState([]);
  const [inventoryRender, setInventoryRender] = useState(1);

  const [searchParams, setSearchParams] = useSearchParams();
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);

  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [render, setRender] = useState(0);
  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || 'asc');
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || 1);
  const [pageSize, setPageSize] = useState(searchParams.get('pageSize') || 20);
  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);

  const [eventDate, setEventDate] = useState(null);
  const [eventEndDate, setEventEndDate] = useState(new Date());

  const registerOptions = (row) => {
    if (props?.reservation != null) {
      return <MDButton onClick={() => registerFn(row)}
                       size={'small'}
                       disabled={row.bookedFull}
                       color="info">
        {row.bookedFull ? 'Booked Full' : 'Move'}
      </MDButton>
    } else if (!row?.eventType?.requireAttendees && row.memberAccountTypes?.length > 0) {
      return <div>
        {row.memberAccountTypes.map((_row, index) => {
          return (<MDButton onClick={() => registerMembershipEvent(row, _row)}
                            size={'small'}
                            className="m-1"
                            key={index}
                            disabled={row.bookedFull}
                            color="info">
            {row.bookedFull ? 'Booked Full' : 'Register'} ({_row.name})
          </MDButton>)
        })
        }
      </div>
    } else {
      return <div>
        {row?.eventType?.requireAttendees && row.memberAccountTypes?.length > 0 && <div className={'d-block mb-2'} style={{
          marginTop:'-16px'
        }}>
          {row.memberAccountTypes.map((_row, index) => {
            return(<span key={index}>
                <Chip
                  size={'small'}
                  variant={'outlined'}
                  label={_row.name}
                  className={'m-chip'}
                  color={'secondary'}/>
            </span>)
          })}
        </div>}

        <MDButton onClick={() => registerFn(row)}
                  size={'small'}
                  disabled={row.bookedFull}
                  color="info">
          {row.bookedFull ? 'Booked Full' : 'Register'}
        </MDButton>

      </div>
    }
  }

  useEffect(() => {
    if (!eventDate) {
      return;
    }
    let startDate = new Date(eventDate);
    startDate.setHours(0, 0, 0, 0);
    let endDate = new Date(startDate);
    let req = {
      start: startDate,
      end: endDate,
      specialEvents: specialEvents
    }
    if (props?.reservation) {
      req.eventType = {
        id: props.reservation?.event?.eventType?.id,
      }
      req.inventoryGuid = props?.reservation?.eventGuid
    }
    getInventoryEventsFn(req, props?.client);
  }, [eventDate]);


  const getInventoryEventsFn = async (req, client) => {
    setEventsLoading(true);
    let result = client ? await getClientInventoryEvents(req, client, inventoryRender) : await getInventoryEvents(req, inventoryRender);
    setEvents(result.events);
    setEventsLoading(false);
    setLoading(false);
  }

  const updateEventDates = (date) => {
    setEventDate(date);
    setEventEndDate(addDate(date, 1));
  }

  const {register, handleSubmit, setValue, control} = useForm({});

  const FormattedDateInput = forwardRef(({value, onClick}, ref) => (
    <div className={'cursor-pointer'} onClick={onClick} ref={ref}>
      <Icon sx={{
        marginTop: '2px',
      }}>event</Icon>{formatDate(eventDate)}
    </div>
  ));

  const handleRowClick = (row) => {
    events.map((_row) => {
      _row.selected = false;
    });
    row.selected = true;
    setEvents(events);
  }

  const conditionalRowStyles = [
    {
      when: row => row.selected,
      style: {
        backgroundColor: "#d7d5d5",
        userSelect: "none"
      }
    }
  ];

  const [buttonGroupActive, setButtonGroupActive] = useState('all');

  const eventFilter = (event) => {
    if ('all' === buttonGroupActive) {
      return true;
    } else if ('parties' === buttonGroupActive) {
      return event.eventType?.specialEvent;
    } else {
      return !!!event.eventType?.specialEvent;
    }
  }

  return (
    <>
      <MDBox>
        <Grid container spacing={2}>

          <Grid item xs={6} sm={4}>
            <MDBox width="100%" lineHeight={1}>
              <DesktopDatePicker
                slotProps={{
                  actionBar: {
                    actions: ['today'],
                  },
                }}
                value={dayjs(eventDate)}
                onChange={(e) => {
                  updateEventDates(e?.$d || null);
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={6} sm={8}>
            <MDBox width="100%">
              <ButtonGroup className={'mb-2 pull-right'}
                           variant="outlined"
                           size="small"
                           aria-label="Event Types">

                <Button
                  size="small"
                  key={'active'}
                  style={{
                    color: buttonGroupActive === 'all' ? '#fff' : '#111',
                    background: buttonGroupActive === 'all' ? '#111' : '#fff',
                    borderColor: '#111'
                  }}
                  onClick={(e) => {
                    setButtonGroupActive('all')
                  }}>
                  All
                </Button>

                <Button
                  size="small"
                  key={'active'}
                  style={{
                    color: buttonGroupActive === 'parties' ? '#fff' : '#111',
                    background: buttonGroupActive === 'parties' ? '#111' : '#fff',
                    borderColor: '#111'
                  }}
                  onClick={(e) => {
                    setButtonGroupActive('parties')
                  }}>
                  Parties
                </Button>

                <Button
                  size="small"
                  key={'active'}
                  style={{
                    color: buttonGroupActive === 'events' ? '#fff' : '#111',
                    background: buttonGroupActive === 'events' ? '#111' : '#fff',
                    borderColor: '#111'
                  }}
                  onClick={(e) => {
                    setButtonGroupActive('events')
                  }}>
                  Events
                </Button>


              </ButtonGroup>
            </MDBox>
          </Grid>


        </Grid>
        <Divider/>

        <Grid container spacing={2}>

          <Grid item xs={12}>
            {eventsLoading && <Loading/>}
            {!eventsLoading && events?.length === 0 && <>
              <center>
                <MDTypography variant={'p'} className={'cursor-default'}
                              fontWeight={'light'}>No events found
                  for {formatDate(eventDate)}</MDTypography>
              </center>
            </>}
            {!eventsLoading && events?.filter((event) => eventFilter(event)).sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
              .map((event, index) => {
                return (
                  <div key={index}>
                    <Row>
                      <Col xs={12} sm={6}>
                        {event?.imageUrl && <Avatar alt={event?.name}
                                                    variant={"square"}
                                                    sx={{
                                                      width: 86, height: 86,
                                                      float: 'left', margin: '0 10px 10px 10px'
                                                    }}
                                                    src={event?.imageThumbUrl || event?.imageUrl}
                        />
                        }
                        <h5>
                          <a href={'/event/view/' + event.guid}>{event.name}</a>
                        </h5>
                        {event?.sessionEvent && <MDTypography variant="h6" fontWeight="light" color="secondary">
                          Session
                        </MDTypography>
                        }

                        {props?.hideDesc ? <>&nbsp;</> : <blockquote>{event.desc}</blockquote>}
                      </Col>
                      <Col xs={12} sm={5}>
                        <p>
                          <small>Type: <b>{event.eventType?.name}</b></small><br/>
                          <small>
                            Price:&nbsp;
                            {event?.eventType?.memberOnly ? <b>Membership Required</b> :
                              <b>{formatCurrency(event.price)}</b>}
                            <br/>
                          </small>
                          <small>
                            Age(s): <b>{event.ageRange?.name}</b>
                            <br/>
                          </small>
                          <small>
                            Available: <b>{inventoryAvailable(event)}</b>
                            <br/>
                          </small>
                          {event?.sessionEvent && <small>
                            Session Event: <b>Yes</b>
                            <br/>
                          </small>}
                          <small>
                            Event
                            Date: <b>{displayDay(event.eventDate, 'MM/DD/YYYY hh:mm a')} - {displayDay(event.eventEndDate, 'hh:mm a')}</b>
                          </small>
                        </p>
                        {registerOptions(event)}
                        {/*<MDButton onClick={() => registerFn(event)}*/}
                        {/*          size={'small'}*/}
                        {/*          disabled={event.bookedFull}*/}
                        {/*          color="info">*/}
                        {/*  {event.bookedFull ? 'Booked Full' : 'Register'}*/}
                        {/*</MDButton>*/}
                      </Col>
                      <Divider/>
                    </Row>
                  </div>
                )
              })
            }
          </Grid>
        </Grid>

      </MDBox>
    </>
  )
}